// function loadRecaptchaNewsletter() {
//
//     grecaptcha.execute(recaptchaKeyV3, { action: 'submit' }).then(function (token) {
//         var recaptchaResponse = document.getElementById('newsletter_recaptcha');
//         recaptchaResponse.value = token;
//
//         $.ajax({
//             type: "POST",
//             data: new FormData(document.getElementById("newsletter-form")),
//             dataType: "json",
//             url: ajaxUrlNewsletter,
//             processData: false,
//             contentType: false,
//             success: function(data) {
//                 $('[data-response-contact="true"]').html(data.html);
//                 console.log('success');
//             },
//             error: function(data) {
//                 $('[data-response-contact="true"]').html(data.responseJSON.html);
//                 console.log('fail');
//
//             }
//         });
//     });
// }
//
// $('form#newsletter-form').on('submit', function(e) {
//     e.preventDefault();
//     loadRecaptchaNewsletter();
// });
//
//
//
// $('#button-subscribe-newsletter').on('click', function(e){
//     $('#newsletter_email').val($('#newsletter_first_email').val());
// })
//

// $('.js-newsletter-init').on('click', function () {
//     $('.js-newsletter-showable').removeClass('d-none');
// })

function showNewsletterGuida(scope)
{
    if (typeof scope == 'undefined') {
        scope = '';
    }
    $('#modalGuidaContent').html('<iframe src="/api/v1/newsletter_guida?scope='+scope+'" width="100%" height="500" loading="lazy"></iframe>');
    $('#modalGuida').modal('show');
}

$(document).on('click', 'button[form="sib-form"][type="submit"]', function () {
    dataLayer.push({
        event: 'submit',
        context_submitted: 'newsletter'
    });
    fbq_track('Lead');
})

window.addEventListener('message', function(event) {
    if (event.data && typeof event.data.event != 'undefined') {
        if (event.data.event == 'newsletter_submit') {
            dataLayer.push({
                event: 'submit',
                context_submitted: 'newsletter'
            });
            fbq_track('Lead');
        }
    }
});